<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>الفروع</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                            هنا يتم عرض جميع فروع الشركة
                                <div v-show="$per.value.saveBranche" class='pull-left' style='padding=0px'>
                                    <button @click='showForm(0)' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                                      <b>  إضافة جديد </b>
                                    </button>
                                </div>
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                    <thead>
                                      <tr>
                                          <th style='text-align: center'>الاسم</th>
                                          <th style='text-align: center'>المدير</th>
                                          <th style='text-align: center'>التليفون</th>
                                          <th style='text-align: center'>العنوان</th>
                                          <th style='text-align: center'>الاجراء</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <tr class='odd gradeX' v-for='record in records' :key='record.id'>

                                          <td align='center'>{{record.name}}</td>
                                          <td align='center'>{{record.manager}}</td>
                                          <td align='center'>{{record.phone}}</td>
                                          <td align='center'>{{record.address}}</td>
                                          <td align='center'>
                                              <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                                              <button v-show="$per.value.deleteBranche" @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                                              <button v-show="$per.value.editBranche" @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>تعديل</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- Modal -->
             <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
                 <div class='modal-dialog  modal-lg'>
                     <div class='modal-content'>
                         <div class='modal-header'>
                             <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
                             <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
                         </div>
                         <form role='form'>
                         <div class='modal-body'>
                           <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                             <ul v-if='validationErrors'>
                                 <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                             </ul>
                           </div>
                           <div class='alert alert-success alert-dismissable' v-if='successShow'>
                              {{success}}
                           </div>
                           <fieldset>
                                 <input v-model='record.id' name='id' type='text' hidden>

                                 <div class='form-group col-lg-6 col-sm-6'>
                                     <label>اسم الفرع:</label>
                                     <input v-model='record.name' class='form-control' name='name' type='text'>
                                 </div>
                                 <div class='form-group col-lg-6 col-sm-6'>
                                     <label>الاسم التجارى:</label>
                                     <input v-model='record.trade_name' class='form-control' name='name' type='text'>
                                 </div>
                                 <div class='form-group col-lg-6 col-sm-6'>
                                     <label>المدير:</label>
                                     <input v-model='record.manager' class='form-control' name='manager' type='text'>
                                 </div>
                                 <div class='form-group col-lg-6 col-sm-6'>
                                     <label>التليفون:</label>
                                     <input v-model='record.phone' class='form-control' name='phone' type='text'>
                                 </div>
                                 <div class='form-group col-lg-12 col-sm-12'>
                                     <label>العنوان:</label>
                                     <input v-model='record.address' class='form-control' name='address' type='text'>
                                 </div>
                                 <div class="form-group col-lg-3 col-sm-6">
                                   <label>السجل التجارى:</label>
                                   <input style="text-align:center" v-model="record.tax_record" class="form-control" name="tax_record" type="text">
                                 </div>
                                 <div class="form-group col-lg-3 col-sm-6">
                                   <label>البطاقة الضريبية:</label>
                                   <input style="text-align:center" v-model="record.tax_card" class="form-control" name="tax_card" type="text">
                                 </div>
                                 <div class="form-group col-lg-3 col-sm-6">
                                   <label>عنوان الفاتورة:</label>
                                   <input style="text-align:center" v-model="record.Invoice_header" class="form-control" name="Invoice_header" type="text">
                                 </div>
                                 <div class="form-group col-lg-3 col-sm-6">
                                   <label>الـIP:</label>
                                   <input style="text-align:center" v-model="record.ip" class="form-control" name="Invoice_header" type="text">
                                 </div>
                                 <div class="form-group col-lg-3 col-sm-6">
                                   <label>معامل الطباعة X:</label>
                                   <input style="text-align:center" v-model="record.x_rate" class="form-control" name="Invoice_header" type="text">
                                 </div>
                                 <div class="form-group col-lg-3 col-sm-6">
                                   <label>معامل الطباعة Y:</label>
                                   <input style="text-align:center" v-model="record.y_rate" class="form-control" name="Invoice_header" type="text">
                                 </div>
                                 <div class='form-group col-lg-3 col-sm-6'>
                                 <label>نوع الورق</label>
                                 <select class="form-control" style="padding: 0px" v-model="record.paper_size">
                                   <option v-for="item in paperSize" v-bind:key="item.id" v-bind:value="item.id">
                                     {{ item.name}}
                                   </option>
                                 </select>
                               </div>
                               <div class="form-group col-lg-6 col-sm-6">
                                 <label>وقت بداية العمل فى الفرع:</label>
                                 <input style="text-align:center" v-model="record.start_time" class="form-control" name="Invoice_header" type="text">
                               </div>
                               <div class="form-group col-lg-6 col-sm-6">
                                 <label>وقت نهاية العمل فى الفرع:</label>
                                 <input style="text-align:center" v-model="record.end_time" class="form-control" name="Invoice_header" type="text">
                               </div>
                             </fieldset>
                           </div>
                           <div class='modal-footer'>
                               <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
                               <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                               <button @click='saveData' type='button' class='btn btn-primary'>حفظ</button>
                           </div>
                         </form>
                     </div>
                     <!-- /.modal-content -->
                 </div>
                 <!-- /.modal-dialog -->
             </div>
             <!-- /.modal -->
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'Branche',
  data () {
    return {
      paperSize: [
        {id: 0, name: 'صغير'},
        {id: 1, name: 'كبير'}
      ],
      validationErrors: '',
      records: {},
      record: {},
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      branches: {},
      isLoadingSave: false,
      isLoadingDelete: false,
      title: ''
    }
  },
  created () {
    this.GetData()
  },
  methods: {
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getBranche', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.title = 'إضافة سجل جديد'
        this.record = {'id': 0, 'uid': '', 'name': '', 'manager': '', 'phone': '', 'address': '', 'trade_name': '', 'tax_record': '', 'tax_card': '', 'Invoice_header': '', ip: '', 'x_rate': 0, 'y_rate': 0, 'paper_size': 1, 'start_time': '00:00:00', 'end_time': '23:59:59'}
      } else {
        this.title = 'تعديل بيانات سجل'
        this.record = recID
      }
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveBranche', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        uid: this.record.uid,
        name: this.record.name,
        trade_name: this.record.trade_name,
        manager: this.record.manager,
        phone: this.record.phone,
        address: this.record.address,
        tax_record: this.record.tax_record,
        tax_card: this.record.tax_card,
        Invoice_header: this.record.Invoice_header,
        x_rate: this.record.x_rate,
        y_rate: this.record.y_rate,
        ip: this.record.ip,
        paper_size: this.record.paper_size,
        start_time: this.record.start_time,
        end_time: this.record.end_time
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.records.push(res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deleteBranche', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/company/Branches.vue